import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { ProEntryProvider, useProEntry } from '../../contexts/ProEntryContext';
import { DIRECTORY_TYPE_META } from '../../types/annuaire';
function ProEntrySelector() {
    const { entries, activeEntryId, setActiveEntryId, isLoading } = useProEntry();
    if (isLoading || entries.length === 0)
        return null;
    if (entries.length === 1) {
        const e = entries[0];
        return (_jsxs("div", { className: "mb-4 flex items-center gap-2 text-sm", children: [_jsx("span", { className: "text-gray-400", children: "Fiche\u00A0:" }), _jsx("span", { className: "font-medium text-gray-700", children: e.name })] }));
    }
    return (_jsxs("div", { className: "mb-4 flex items-center gap-2", children: [_jsx("label", { className: "text-sm text-gray-500", children: "Fiche active\u00A0:" }), _jsx("select", { value: activeEntryId ?? '', onChange: (e) => setActiveEntryId(Number(e.target.value)), className: "px-3 py-1.5 border rounded-lg text-sm", children: entries.map((e) => (_jsxs("option", { value: e.id, children: [e.name, " (", DIRECTORY_TYPE_META[e.type]?.label ?? e.type, ")"] }, e.id))) })] }));
}
function ProShell() {
    const { entries, isLoading } = useProEntry();
    if (!isLoading && entries.length === 0) {
        return (_jsxs("div", { className: "bg-white rounded-lg border border-gray-200 p-8 text-center text-sm text-gray-500", children: ["Aucune fiche ne vous est rattach\u00E9e pour le moment.", _jsx("br", {}), "Contactez votre mairie pour \u00EAtre rattach\u00E9 \u00E0 un commerce, une association ou un lieu culturel."] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(ProEntrySelector, {}), _jsx(Outlet, {})] }));
}
export default function ProLayout() {
    return (_jsx(ProEntryProvider, { children: _jsx(ProShell, {}) }));
}
